import { colors, type ColorValue } from '@frontend/constants';
import type { CommonSVGProps } from './helpers';

export const CompletedTaskBadge = ({
  backgroundColor = colors.slate['950'],
  fill = colors.green['400'],
  stroke = colors.neutral['50'],
  ...props
}: CommonSVGProps & { backgroundColor?: ColorValue }) => (
  <svg fill="none" viewBox="0 0 16 17" {...props}>
    <rect fill={backgroundColor} height={14.6} rx={7.3} width={14.6} x={0.7} y={1.2} />
    <rect height={14.6} rx={7.3} stroke={stroke} strokeWidth={1.4} width={14.6} x={0.7} y={1.2} />
    <path
      d="M11.332 2.725a6.667 6.667 0 1 1-9.997 5.99l-.003-.216.003-.216a6.667 6.667 0 0 1 9.997-5.558Zm-.862 3.969a.667.667 0 0 0-.88-.055l-.063.055-2.195 2.195-.862-.862-.063-.055a.667.667 0 0 0-.935.935l.055.063 1.334 1.333.062.056a.667.667 0 0 0 .818 0l.062-.056 2.667-2.666.055-.063a.667.667 0 0 0-.055-.88Z"
      fill={fill}
    />
  </svg>
);
